module.exports = __webpack_public_path__ + "static/img/business4.17577c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business4.jpg
// module id = 2cR8
// module chunks = 9